export class MasterVO{
public PICKUP_MODE:any;
public COURIER:any;
public PAYMENT_MODE:any;
public MANUFACTURER:any;
public ENCODING:any;
public SEAL_CONDITION:any;
public MOVEMENT_TYPE:any; 
public STUFFING_TYPE:any;  
public ATTACHMENT_TYPE:any;
public INVOICE_CURRENCY:any;                           
public FREIGHT_CURRENCY:any;
public SHIPMENT_MODE:any;
public IMPORT_PURCHASE_STATUS:any;
public PURPOSE:any;
public PURCHASE_PAYMENT_MODE:any;  
public BILL_TYPE:any;
public PO_STATUS:any;
public FINANCIAL_YEAR:any;
public CUSTOMS_CANCEL_REASON_FOR_REJECT:any;
public CUSTOMS_CANCEL_REASON_FOR_TAMPER:any;
public USER_CANCEL_REASON:any;  
public IMPORT_FROM:any; 
public READER_TYPE:any;
                        
}


// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/model/MasterVO.ts